const DescriptionRowPattern = /<tr[^>]*>\s*<t[hd][^>]*>([^<]*)<\/t[hd]>\s*<td[^>]*>((?:(?!<\/?t[dhr][\s>])[\s\S])*)<\/td>\s*<\/tr>/gi;
const HrefPattern = /<a\s[^>]*href\s*=\s*["']([^"']+)["']/i;
const HtmlTagPattern = /<[^>]+>/g;
const WhitespacePattern = /\s+/g;
const UrlPattern = /https?:\/\/[^\s<>"]+[^\s<>".,;:!?)\]]/gi;

const childElements = (element, localName) =>
    Array.from(element.children).filter(child => child.localName === localName);

const childElement = (element, localName) => childElements(element, localName)[0] ?? null;

export default {
    decodeHtml(text) {
        if (!text) {
            return "";
        }

        return new DOMParser().parseFromString(text, "text/html").documentElement.textContent ?? "";
    },

    stripHtml(html) {
        const withoutTags = (html ?? "").replace(HtmlTagPattern, " ");

        return this.decodeHtml(withoutTags).replace(WhitespacePattern, " ").trim();
    },

    readExtendedData(placemark) {
        const values = {};
        const extendedData = childElement(placemark, "ExtendedData");

        if (!extendedData) {
            return values;
        }

        childElements(extendedData, "SchemaData").forEach(schemaData => {
            childElements(schemaData, "SimpleData").forEach(field => {
                const name = field.getAttribute("name");
                if (name) {
                    values[name] = field.textContent ?? "";
                }
            });
        });
        childElements(extendedData, "Data").forEach(field => {
            const name = field.getAttribute("name");
            if (name) {
                values[name] = childElement(field, "value")?.textContent ?? "";
            }
        });

        return values;
    },

    readDescriptionAttributes(description) {
        const attributes = {};

        if (!description || description.trim() === "") {
            return attributes;
        }

        for (const row of description.matchAll(DescriptionRowPattern)) {
            const name = this.decodeHtml(row[1]).trim();
            const href = row[2].match(HrefPattern);
            const value = href ? this.decodeHtml(href[1]).trim() : this.stripHtml(row[2]);

            if (name) {
                attributes[name] = value;
            }
        }

        return attributes;
    },

    getPlacemarkInfo(placemark) {
        const name = childElement(placemark, "name")?.textContent?.trim() ?? "";
        const rawDescription = childElement(placemark, "description")?.textContent ?? "";
        const extendedData = this.readExtendedData(placemark);
        const hasExtendedData = Object.keys(extendedData).length > 0;
        const attributes = hasExtendedData ? extendedData : this.readDescriptionAttributes(rawDescription);

        let description = null;
        if (rawDescription.trim() !== "" && (hasExtendedData || Object.keys(attributes).length === 0)) {
            description = this.stripHtml(rawDescription) || null;
        }

        return { name, description, attributes };
    },

    splitLinks(text) {
        const segments = [];
        const value = text ?? "";
        let index = 0;

        for (const match of value.matchAll(UrlPattern)) {
            if (match.index > index) {
                segments.push({ text: value.substring(index, match.index) });
            }

            segments.push({ text: match[0], url: match[0] });
            index = match.index + match[0].length;
        }

        if (index < value.length) {
            segments.push({ text: value.substring(index) });
        }

        return segments;
    }
}
